import { render, staticRenderFns } from "./labelgroups-table.vue?vue&type=template&id=e4201754&scoped=true"
import script from "./labelgroups-table.vue?vue&type=script&lang=js"
export * from "./labelgroups-table.vue?vue&type=script&lang=js"
import style0 from "./labelgroups-table.vue?vue&type=style&index=0&id=e4201754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4201754",
  null
  
)

export default component.exports